import {BaseModalProps, BmBaseModal} from "../../BaseModal";
import {styles} from "./FullModal.styles";

export const BmFullModal: React.FC<BaseModalProps> = ({children, ...props}) => {
  return (
    <BmBaseModal className={styles.modalWrap} bodyClassName={styles.body} {...props}>
      {children}
    </BmBaseModal>
  );
};
